export const setUsuarios = (state, usuarios) => {
  state.usuarios = usuarios
}
